export default __webpack_public_path__ + "static/media/Infrastructure.052f2dd5.JPG";